/* eslint-disable import/extensions */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './components/App/App.js';
import reportWebVitals from './reportWebVitals';

// Hack pour résoudre les problèmes d'authentification et d'erreurs de communication
window.ENABLE_DEBUG = true;
window.API_URL = 'https://drivesoft-v2-anhu4.ondigitalocean.app';

// Vérifier le token au démarrage de l'application
const token = localStorage.getItem('token');
console.log('Application: Token présent au démarrage?', !!token);

// Fonction pour gérer les erreurs non interceptées
window.addEventListener('unhandledrejection', (event) => {
  console.error('Erreur non interceptée:', event.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Désactivation du StrictMode pour éviter les doubles montages/appels API
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
